import React from 'react'
import Sidesheet from './index'

const ModalSidesheet = ({ children, onClose, title }) => {
  return (
    <Sidesheet isModal={true} onClose={onClose} title={title}>
      {children}
    </Sidesheet>
  )
}

export default ModalSidesheet


// WEBPACK FOOTER //
// ./src/scripts/components/Sidesheet/modal.js